(function () {
  function initStoryLab(root) {
    const callouts = root.querySelectorAll('.story-lab__callout');
    const details = root.querySelectorAll('.story-lab__callout-detail');
    if (!callouts.length) return;

    callouts.forEach((btn) => {
      if (btn.dataset.storyLabBound) return;
      btn.dataset.storyLabBound = 'true';
      btn.addEventListener('click', () => {
        const idx = btn.dataset.calloutIndex;
        callouts.forEach((c) => {
          c.classList.toggle('is-active', c === btn);
          c.setAttribute('aria-expanded', c === btn ? 'true' : 'false');
        });
        details.forEach((d) => {
          const active = d.dataset.calloutDetail === idx;
          d.classList.toggle('is-active', active);
          d.hidden = !active;
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.story-lab[data-section-id]').forEach(initStoryLab);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.story-lab[data-section-id]');
    if (section) initStoryLab(section);
  });
})();
